import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync, faDownload, faTimes } from '@fortawesome/free-solid-svg-icons';
import updateChecker from '../utils/updateChecker';

const UpdateNotification = () => {
    const [showUpdate, setShowUpdate] = useState(false);
    const [updateMessage, setUpdateMessage] = useState('');
    const [isUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
        // Start checking for updates
        updateChecker.startChecking((updateInfo) => {
            if (updateInfo.type === 'update_available') {
                setUpdateMessage(updateInfo.message);
                setShowUpdate(true);
            } else if (updateInfo.type === 'update_installed') {
                setUpdateMessage(updateInfo.message);
                setShowUpdate(false);
                // Show success message briefly
                setTimeout(() => {
                    setUpdateMessage('');
                }, 3000);
            }
        });

        // Cleanup on unmount
        return () => {
            updateChecker.stopChecking();
        };
    }, []);

    const handleUpdate = async () => {
        setIsUpdating(true);
        try {
            await updateChecker.forceUpdate();
        } catch (error) {
            console.error('Update failed:', error);
            setIsUpdating(false);
        }
    };

    const handleDismiss = () => {
        setShowUpdate(false);
    };

    const handleClearCache = async () => {
        setIsUpdating(true);
        try {
            await updateChecker.clearCacheAndReload();
        } catch (error) {
            console.error('Cache clear failed:', error);
            setIsUpdating(false);
        }
    };

    if (!showUpdate) {
        return null;
    }

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 9999,
            maxWidth: '400px',
            minWidth: '300px'
        }}>
            <Alert 
                variant="info" 
                className="shadow-lg border-0"
                style={{ borderRadius: '10px' }}
            >
                <div className="d-flex align-items-start">
                    <div className="flex-grow-1">
                        <div className="d-flex align-items-center mb-2">
                            <FontAwesomeIcon 
                                icon={faDownload} 
                                className="me-2 text-primary"
                                size="lg"
                            />
                            <strong>Update Available</strong>
                        </div>
                        <p className="mb-3 text-muted">
                            {updateMessage} Click update to get the latest features and improvements.
                        </p>
                        <div className="d-flex gap-2">
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={handleUpdate}
                                disabled={isUpdating}
                            >
                                {isUpdating ? (
                                    <>
                                        <FontAwesomeIcon icon={faSync} spin className="me-2" />
                                        Updating...
                                    </>
                                ) : (
                                    <>
                                        <FontAwesomeIcon icon={faSync} className="me-2" />
                                        Update Now
                                    </>
                                )}
                            </Button>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={handleClearCache}
                                disabled={isUpdating}
                            >
                                Clear Cache
                            </Button>
                        </div>
                    </div>
                    <Button
                        variant="link"
                        size="sm"
                        onClick={handleDismiss}
                        className="p-0 ms-2"
                        style={{ color: '#6c757d' }}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </div>
            </Alert>
        </div>
    );
};

export default UpdateNotification;
